var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',_vm._g(_vm._b({attrs:{"size":_vm.size}},'v-avatar',_vm.$attrs,false),_vm.$listeners),[_c('span',{staticClass:"initials-icon",attrs:{"aria-label":_vm.givenName + _vm.surname}},[_vm._v(" "+_vm._s(_vm.initials)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }